import { ActionMap } from 'action-typed';

import type { CookieCategories, CookieScan } from './types';

export enum CookieBannerEvents {
    CLEANUP = 'CookieBanner.CookieCleanup',
    CONSENT = 'CookieBanner.Consent',
    CONSENT_SERVICES = 'CookieBanner.ServicesConsent',
    CUSTOM_SERVICES_DETECTED = 'CookieBanner.CustomServicesDetected',
    INITIALIZED = 'CookieBanner.Initialized',
    LATEST_SCAN = 'CookieBanner.LatestScan',
    LOADED = 'CookieBanner.ConsentLoaded',
    LOADED_SERVICES = 'CookieBanner.ServicesConsentLoaded',
    READY = 'CookieBanner.Ready',
}

export enum CookieFirstEvents {
    CONSENT = 'cf_consent',
    CONSENT_SERVICES = 'cf_services_consent',
    INITIALIZED = 'cf_init',
    LOADED = 'cf_consent_loaded',
    LOADED_SERVICES = 'cf_services_consent_loaded',
    READY = 'cf_layer_ready',
}

export type Messages = {
    [CookieBannerEvents.CLEANUP]?: {
        categories: CookieCategories;
        cookiesRemoved: string[];
    };
    [CookieBannerEvents.CONSENT_SERVICES]?: CookieCategories;
    [CookieBannerEvents.CONSENT]?: CookieCategories;
    [CookieBannerEvents.CUSTOM_SERVICES_DETECTED]?: {
        description?: string;
        enabled?: boolean;
        name?: string;
    }[];
    [CookieBannerEvents.INITIALIZED]: void;
    [CookieBannerEvents.LATEST_SCAN]?: CookieScan;
    [CookieBannerEvents.LOADED_SERVICES]?: CookieCategories;
    [CookieBannerEvents.LOADED]?: CookieCategories;
    [CookieBannerEvents.READY]?: void;
};

export type TypeMap = ActionMap<Messages>;
export type CookieBannerActions = TypeMap[keyof TypeMap];
